export default {
    namespaced: true,
    state: {
      roulleteItems: [],
    },
    mutations: {
      SET_ROULETTE_ITEMS(state, items) {
        state.roulleteItems = items;
      },
    },
    actions: {
    }
  };
  